export default "__VITE_ASSET__DeqBGabS__"